import React from 'react';
import PropTypes from 'prop-types';
import css from './Text.module.scss';

const SIZE_CLASS = {
  xs: css.xs,
  small: css.small,
  regular: css.regular,
};

const COLOR_CLASS = {
  text: css.colorText,
  muted: css.colorMuted,
  primary: css.colorPrimary,
  success: css.colorSuccess,
  danger: css.colorDanger,
  warning: css.colorWarning,
  caution: css.colorCaution,
};

const WEIGHT_CLASS = {
  normal: css.weightNormal,
  semibold: css.weightSemibold,
  bold: css.weightBold,
};

const Text = ({
  children,
  size = 'regular',
  color = 'text',
  weight = 'normal',
  truncate = false,
  strikethrough = false,
  as: Tag = 'span',
  className,
  style,
  ...props
}) => {
  const classNames = [
    css.text,
    SIZE_CLASS[size],
    COLOR_CLASS[color],
    WEIGHT_CLASS[weight],
    truncate && css.truncate,
    strikethrough && css.strikethrough,
    className,
  ].filter(Boolean).join(' ');

  return (
    <Tag className={classNames} style={style} {...props}>
      {children}
    </Tag>
  );
};

Text.propTypes = {
  children: PropTypes.node,
  size: PropTypes.oneOf(['xs', 'small', 'regular']),
  color: PropTypes.oneOf(['text', 'muted', 'primary', 'success', 'danger', 'warning', 'caution']),
  weight: PropTypes.oneOf(['normal', 'semibold', 'bold']),
  truncate: PropTypes.bool,
  strikethrough: PropTypes.bool,
  as: PropTypes.elementType,
  className: PropTypes.string,
  style: PropTypes.object,
};

export default Text;
